export default {
  state: {
    totalPrice: null
  },
  getters: {
    totalPrice: state => Math.ceil(state.totalPrice * 100)
  },
  mutations: {
    setTotaslPrice: (state, payload) => {
      state.totalPrice = payload;
    }
  },
  actions: {},
  namespaced: true
};
